import { NgTemplateOutlet } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, inject, signal } from "@angular/core";
import { AccountMarketplace, AccountType } from "@front/m19-api-client";
import {
  IButtonDirective,
  ILabelComponent,
  ISelectMenuImports,
  ITooltipDirective,
  MarketplaceFlagComponent,
  MODAL_DATA,
  ModalRef,
} from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";

export interface GrantOrganicDataAccessModalData {
  accountMarketplaces: AccountMarketplace[];
}

@Component({
  selector: "app-grant-organic-data-access-modal",
  templateUrl: "./grant-organic-data-access-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgTemplateOutlet,
    TranslocoDirective,
    IButtonDirective,
    ILabelComponent,
    MarketplaceFlagComponent,
    ISelectMenuImports,
    ITooltipDirective,
  ],
})
export class GrantOrganicDataAccessModalComponent {
  private readonly data = inject<GrantOrganicDataAccessModalData>(MODAL_DATA);
  readonly ref = inject(ModalRef);

  readonly accountMarketplaces = this.data.accountMarketplaces;
  readonly selected = signal<AccountMarketplace>(this.accountMarketplaces[0]);
  readonly amazonCentral = computed(() =>
    this.selected().accountType === AccountType.VENDOR ? "Vendor Central" : "Seller Central",
  );

  select(accountMarketplace: AccountMarketplace | undefined) {
    if (accountMarketplace) {
      this.selected.set(accountMarketplace);
    }
  }

  grant() {
    this.ref.close(this.selected());
  }
}
